import { Home, Calendar, MessageCircle, User, Activity, Users, FileText, Bell, LucideIcon } from 'lucide-react';
import { Badge } from '../ui/badge';

interface NavItem {
  id: string;
  label: string;
  icon: LucideIcon;
  badge?: number;
  active?: boolean;
}

interface BottomNavProps {
  items: NavItem[];
  activeItem: string;
  onItemClick: (itemId: string) => void;
  className?: string;
}

export function BottomNav({
  items,
  activeItem,
  onItemClick,
  className = ''
}: BottomNavProps) {
  return (
    <div className={`fixed bottom-0 left-0 right-0 bg-card border-t border-border ${className}`}>
      <div className="flex items-center justify-around h-16 max-w-screen-xl mx-auto px-4">
        {items.map((item) => {
          const Icon = item.icon;
          const isActive = activeItem === item.id;

          return (
            <button
              key={item.id}
              onClick={() => onItemClick(item.id)}
              className={`flex flex-col items-center justify-center gap-1 flex-1 h-full transition-colors relative ${
                isActive
                  ? 'text-primary'
                  : 'text-muted-foreground hover:text-foreground'
              }`}
            >
              <div className="relative">
                <Icon className={`h-5 w-5 ${isActive ? 'fill-primary' : ''}`} />
                {item.badge !== undefined && item.badge > 0 && (
                  <Badge
                    variant="destructive"
                    className="absolute -top-2 -right-2 h-4 min-w-4 px-1 flex items-center justify-center"
                  >
                    {item.badge > 9 ? '9+' : item.badge}
                  </Badge>
                )}
              </div>
              <span className={`text-[10px] ${isActive ? '' : ''}`}>
                {item.label}
              </span>
              {isActive && (
                <div className="absolute top-0 left-1/2 -translate-x-1/2 w-12 h-1 bg-primary rounded-b-full" />
              )}
            </button>
          );
        })}
      </div>
    </div>
  );
}
